export default __webpack_public_path__ + "static/media/el17.b4bfb7de.svg";